define('presentation/navigation/viewModels/moreNavigationViewModel',['businessServices/events/eventManager',
    'businessServices/router/router',
    'common/promises/promiseFactory',
    'presentation/common/window/windowControl',
    'presentation/userProfile/facades/userProfileFacade',
    'settings/navigationConfiguration',
    'settings/uiAnimationsConfiguration',
    'businessServices/converters/numberFormatter',
    'presentation/inbox/dataSources/recordingSubscriptionDataSource'
], function (
    /** @type import('businessServices/events/eventManager') */
    eventManager,
    /** @type typeof import('businessServices/router/router') */
    router,
    /** @type typeof import('common/promises/promiseFactory') */
    PromiseFactory,
    /** @type import('presentation/common/window/windowControl') */
    windowControl,
    /** @type typeof import('presentation/userProfile/facades/userProfileFacade') */
    UserProfileFacade,
    /** @type typeof import('settings/navigationConfiguration') */
    navigationConfiguration,
    /** @type import('settings/uiAnimationsConfiguration') */
    UIAnimationsConfig
) {
    return function () {
        const self = this;

        const _promiseFactory = new PromiseFactory();

        const NumberFormatterConstructor = require('businessServices/converters/numberFormatter');
        const _numberFormatter = new NumberFormatterConstructor();

        /** @type {UserProfileFacade['prototype']} */
        let _facade = null;
        /** @type {number} */
        let _hideMoreNavigationOptionsTimeout = null;

        const _callRecordingsSubscriptionsDataSource = require('presentation/inbox/dataSources/recordingSubscriptionDataSource');

        self.newCallRecordingCount = _callRecordingsSubscriptionsDataSource.totalNewMessages;
        self.isMoreNavigationOptionsOpen = ko.observable(false);

        const badgeCount =  ko.computed(() => {
            return self.newCallRecordingCount ? self.newCallRecordingCount() : 0;
        });

        const prefixedBadgeCount = ko.computed(() => _numberFormatter.formatDigitsWithPrefix(badgeCount(), 1));
        const isBadgeVisible =  ko.computed(() => badgeCount() > 0);
        const isBadgeSingleDigit =  ko.computed(() => badgeCount() <= 9);

        self.moreNavigationOptions = ko.computed(() => {
            const options = [
                {
                    textI18n: 'inboxSidebar:headerRecordings',
                    iconName: 'callRecording',
                    prefixedBadgeCount: prefixedBadgeCount,
                    isBadgeVisible: isBadgeVisible,
                    isBadgeSingleDigit: isBadgeSingleDigit,
                    onClick: () => self.navigateToRecordings(),
                    showSeparator: false
                },
                {
                    textI18n: 'sidebarNavigation:contactPermissions',
                    iconName: 'mainNavContacts',
                    prefixedBadgeCount: ko.observable(0),
                    isBadgeVisible: ko.observable(false),
                    isBadgeSingleDigit: ko.observable(false),
                    onClick: () => self.navigateToContacts(),
                    showSeparator: false}
            ];

            return options;
        });

        self.hideMoreNavigationOptions = () => {
            _hideMoreNavigationOptionsTimeout = setTimeout(() => {
                self.isMoreNavigationOptionsOpen(false);
            }, UIAnimationsConfig.presentation_navigation_viewModels_moreNavigationViewModel_hideMoreNavigationOptions);
        };

        self.navigateToContacts = () => {
            self.isMoreNavigationOptionsOpen(false);
            router.navigate(navigationConfiguration.routesById.contacts.url);
        };

        self.navigateToRecordings = () => {
            self.isMoreNavigationOptionsOpen(false);
            router.navigate(navigationConfiguration.routesById.inboxRecordings.url);
        };

        self.resetHideMoreNavigationOptions = () => {
            clearTimeout(_hideMoreNavigationOptionsTimeout);
        };

        self.toggleMoreNavigationOptions = () => {
            self.isMoreNavigationOptionsOpen(!self.isMoreNavigationOptionsOpen());
        };

        self.activate = () => {
            _facade = new UserProfileFacade();
            _facade.init(_promiseFactory);

            return _initialize();
        };

        const _initialize = () => {

            return _promiseFactory.wait();
        };
    };
});

